import { createContext } from 'react';

const PromotionsContext = createContext();

export default PromotionsContext;
